import styled from 'styled-components';
import { Link } from '../../../../components/Link/Link';
export const FooterColumn = styled.ul `
  flex-basis: 16.5%;
  list-style: none;
  z-index: 10;

  li {
    display: block;
    line-height: 34px;

    a {
      line-height: 34px;
    }
  }
`;
export const StyledLink = styled(Link) `
  color: ${({ theme }) => theme.colors.text01};
  text-decoration: none;
  display: inline-block;
  font-weight: 300;

  &:hover {
    text-decoration: underline;
  }
`;
//# sourceMappingURL=FooterLinksColumn.styled.js.map